import React, { Component } from 'react';
import { Image } from 'react-bootstrap';
import DocumentItemMenu from './DocumentItemMenu';

var page = require("../../../content/images/page_icon.png");

export default class DocumentListItem extends Component {
    render() {
        let date = new Date(this.props.date).toLocaleDateString();
        let className = `document${this.props.isSelected ? " selected" : ""}`;

        return (
            <React.Fragment>
                <div className={className}>
                    <span className="document-id">ID: {this.props.id}</span>
                    <div className="page-container">
                        <Image className="page" src={page} fluid onClick={() => this.props.onClick(this.props.id)} />
                        <DocumentItemMenu
                            show={this.props.isSelected}
                            onReview={this.props.onReview}
                            onDelete={this.props.onDelete}
                        />
                    </div>
                    <span>{this.props.filename}</span>
                    <span>{date}</span>
                </div>
            </React.Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Home/DocumentList/DocumentListItem.js